/* eslint-disable max-lines */
import React from "react";
import { useHistory } from "react-router-dom";

import { Column, Row, useCurrentViewPort, ViewPort } from "@gamedev-web/gamedev-sdk-core";

import { getImage, ImageType } from "../../helpers/imageHelper";
import { useStrings } from "../../localization/localizationHelpers";
import { RouteNames } from "../../partnerConfig/routeNames";
import { OnboardingUrls } from "../../partnerConfig/routes";
import { OnboardingPageAction } from "../../telemetry/models";
import { logPageAction } from "../../telemetry/pageAction";
import { ContentBox, ContentBoxIcon } from "../ContentBox";
import { AttributesTable } from "./AttributesTable";
import * as styles from "./ProgramSelector.module.css";
import { idXboxName, pitchName, ProgramColumnConfig } from "./programSelectorUtils";

const renderSelectedProgram = (
  logoImage: string,
  logoImageAltText: string,
  columnsConfig: ProgramColumnConfig[],
  programId: string,
  currentViewPort: ViewPort,
  useFormattedText?: boolean
) => {
  const programImage = <img src={logoImage} className={styles.image} alt={logoImageAltText} />;

  return (
    <ContentBox className={styles.programBox}>
      {currentViewPort >= ViewPort.MD && (
        <Row>
          <Column className={styles.imageColumn}>{programImage}</Column>
          <Column className={styles.programInfoWrapper}>
            <AttributesTable
              columnsConfig={columnsConfig}
              programId={programId}
              useFormattedText={useFormattedText}
            />
          </Column>
        </Row>
      )}
      {currentViewPort < ViewPort.MD && (
        <>
          <Row>{programImage}</Row>
          <Row>
            <Column className={styles.programInfoWrapper}>
              <AttributesTable
                columnsConfig={columnsConfig}
                programId={programId}
                useFormattedText={useFormattedText}
              />
            </Column>
          </Row>
        </>
      )}
    </ContentBox>
  );
};

export const IdXboxSelected = () => {
  const [
    directSupport,
    devKits,
    approvals,
    potentialEndpoints,
    idXboxDirectSupport,
    idXboxDevKits,
    idXboxApprovals,
    idXboxPotentialEndpoints,
    changeProgram,
    selectedProgram,
    idXboxProgramImageAltText,
  ] = useStrings(
    "directSupport",
    "devKits",
    "approvals",
    "potentialEndpoints",
    "idXboxDirectSupport",
    "idXboxDevKits",
    "idXboxApprovals",
    "idXboxPotentialEndpoints",
    "changeProgram",
    "selectedProgram",
    "idXboxProgramImageAltText"
  );
  const history = useHistory();
  const currentViewPort = useCurrentViewPort();
  const changeProgramOnClick = () => {
    history.push(OnboardingUrls[RouteNames.ProgramSelection]);
    logPageAction(OnboardingPageAction.ChangeProgramLink);
  };
  return (
    <ContentBox
      titleConfiguration={{
        title: idXboxName,
        subtitle: selectedProgram,
        icon: ContentBoxIcon.CheckMark,
        separatorBar: true,
        rightSideLink: {
          text: changeProgram,
          onClick: changeProgramOnClick,
          icon: ContentBoxIcon.ArrowsLeftRightSwap,
        },
      }}
    >
      {renderSelectedProgram(
        getImage("idxboxlogo", ImageType.Png),
        idXboxProgramImageAltText,
        [
          {
            title: directSupport,
            content: idXboxDirectSupport,
          },
          {
            title: devKits,
            content: idXboxDevKits,
          },
          {
            title: approvals,
            content: idXboxApprovals,
            doubleSizedColumn: true,
          },
          {
            title: potentialEndpoints,
            content: idXboxPotentialEndpoints,
          },
        ],
        "idxbox",
        currentViewPort
      )}
    </ContentBox>
  );
};

export const PitchSelected = () => {
  const [
    pitchSelectProgramCardColumnOne,
    pitchSelectProgramCardColumnTwo,
    pitchSelectProgramCardColumnThree,
    pitchSelectProgramCardColumnFourth,
    pitchSelectProgramCardDescriptionColumnOne,
    pitchSelectProgramCardDescriptionColumnTwo,
    pitchSelectProgramCardDescriptionColumnThree,
    pitchSelectProgramCardDescriptionColumnFourth,
    changeProgram,
    pitchProgramImageAltText,
  ] = useStrings(
    "pitchSelectProgramCardColumnOne",
    "pitchSelectProgramCardColumnTwo",
    "pitchSelectProgramCardColumnThree",
    "pitchSelectProgramCardColumnFourth",
    "pitchSelectProgramCardDescriptionColumnOne",
    "pitchSelectProgramCardDescriptionColumnTwo",
    "pitchSelectProgramCardDescriptionColumnThree",
    "pitchSelectProgramCardDescriptionColumnFourth",
    "changeProgram",
    "pitchProgramImageAltText"
  );
  const history = useHistory();
  const currentViewPort = useCurrentViewPort();
  const changeProgramOnClick = () => {
    history.push(OnboardingUrls[RouteNames.ProgramSelection]);
    logPageAction(OnboardingPageAction.ChangeProgramLink);
  };
  return (
    <ContentBox
      titleConfiguration={{
        title: pitchName,
        icon: ContentBoxIcon.CheckMark,
        separatorBar: true,
        rightSideLink: {
          text: changeProgram,
          onClick: changeProgramOnClick,
          icon: ContentBoxIcon.ArrowsLeftRightSwap,
        },
      }}
    >
      {renderSelectedProgram(
        getImage("pitchlogo", ImageType.Png),
        pitchProgramImageAltText,
        [
          {
            title: pitchSelectProgramCardColumnOne,
            content: pitchSelectProgramCardDescriptionColumnOne,
          },
          {
            title: pitchSelectProgramCardColumnTwo,
            content: pitchSelectProgramCardDescriptionColumnTwo,
          },
          {
            title: pitchSelectProgramCardColumnThree,
            content: pitchSelectProgramCardDescriptionColumnThree,
            doubleSizedColumn: true,
          },
          {
            title: pitchSelectProgramCardColumnFourth,
            content: pitchSelectProgramCardDescriptionColumnFourth,
          },
        ],
        "pitch",
        currentViewPort,
        true
      )}
    </ContentBox>
  );
};
